import * as React from 'react'
import { css } from '@emotion/react'
import { StaticImage } from 'gatsby-plugin-image'

const Header = () => {
  return (
    <header css={headerStyle}>
      <div css={logoStyle}>
        <a href="https://make.dmm.com/">
          <StaticImage src="../assets/images/logo_make.svg" alt="DMM.make" />
        </a>
      </div>
    </header>
  )
}

const headerStyle = css`
  display: flex;
  justify-content: space-between;
  padding: 12px 12px;
  border-bottom: 1px solid #f7f7f7;
`
const logoStyle = css`
  width: 120px;
  height: 17px;
`

export default Header
